import { usePaymentData } from '@p2p/entities/payment';

import { PaymentWarning } from './PaymentWarning';

export const PaymentWarningPage = () => {
  const { order, pageSettings } = usePaymentData();

  return <PaymentWarning order={order} pageSettings={pageSettings} />;
};
